/**
 * Case-insensitive comparison for social platform ids from API strings and domain enums.
 */
export function isSamePlatformId(a: string | undefined | null, b: string | undefined | null) {
  if (a == null || b == null) {
    return false;
  }

  return a.toUpperCase() === b.toUpperCase();
}
